var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"appear":"","name":"slide-fade","mode":"out-in"}},[_c('v-container',{staticClass:"mt-12",attrs:{"row":"","fluid":""}},_vm._l((_vm.items),function(item,index){return _c('tile-item',{key:index,staticClass:"mr-10",attrs:{"item":item}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }